import { render, staticRenderFns } from "./DevModelForm.vue?vue&type=template&id=add8d7e0&"
import script from "./DevModelForm.vue?vue&type=script&lang=js&"
export * from "./DevModelForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports